<template>
  <div class="list-view">
    <v-list v-if="items.length > 0">
      <list-item v-for="item in items" :key="item.id" :item="{ id: item }" type="category"/>
    </v-list>

    <p v-else>Je hebt nog niets toegevoegd aan deze lijst. Voeg er een toe door op de plus rechts onderin te drukken.</p>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { ListItem } from '@/components/organisms'

  export default {
    name: 'show-category',
    computed: {
      items () {
        const categories = this.getCategories()
        const id = this.$route.params.id
        const currentCategory = categories.find(category => category.id === id)
        if (currentCategory) return currentCategory.items
      }
    },
    methods: {
      ...mapGetters({
        getCategories: 'getCategories',
        getLists: 'getLists',
        getCurrentListID: 'getCurrentListID'
      }),
      addProduct () {
        this.$store.commit('SET_CURRENT_CATEGORY', this.$route.params.id)
        this.$router.push({name: 'addProduct'})
      }
    },
    components: {
      ListItem
    }
  }
</script>

<style lang="scss" scoped>
  p {
    padding: 20px;
    font-size: 24px;
    text-align: center;
    em {
      font-weight: 600;
    }
  }
</style>



// WEBPACK FOOTER //
// ShowCategory.vue?0b44efc7